import styled, { keyframes, css } from "styled-components";

const slideInUp = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(100%);
  }
`;

export const AttentionBoxWrapper = styled.div`
  animation: ${({ isVisible, wasVisible }) =>
    isVisible
      ? css`
          ${slideInUp} 0.5s ease-in-out forwards 0.5s, ${fadeIn} 0.5s ease-in-out forwards 0.5s
        `
      : wasVisible
      ? css`
          ${fadeOut} 0.5s ease-in-out forwards
        `
      : "none"};
  padding: 15px 10px 30px 30px;
  opacity: 0;
  background-color: ${({ theme }) => theme.colors.dataViz.attentionBoxBgColor};
  display: flex;
  gap: 33px;
`;

export const MetricDescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.dataViz.attentionBoxTitleColor};
  font-weight: 600;
  font-size: 14px;
`;

export const SectionTitle = styled.div`
  margin-bottom: 16px;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: ${({ theme }) => theme.colors.dataViz.attentionBoxSectionTitleColor};
`;

export const DescriptionSection = styled.div`
  max-width: 580px;
  width: 100%;
`;

export const Divider = styled.div`
  height: 80px;
  width: 1px;
  background-color: ${({ theme }) => theme.colors.dataViz.attentionBoxDividerColor};
`;

export const Performance = styled.div`
  flex: 1;
`;

export const Message = styled.div`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  color: ${({ theme }) => theme.colors.dataViz.attentionBoxTextColor};
`;
export const Bold = styled.span`
  font-weight: 600;
`;
